import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class EmployeeMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.employee.employeeMapperError"));

        Object.setPrototypeOf(this, EmployeeMapperError.prototype);
    }
}